export const SET_IS_FETCHING = 'reports/SET_IS_FETCHING'
export const SET_GLOBAL_DATA = 'reports/SET_GLOBAL_DATA'
export const SET_POSITION_DATA = 'reports/SET_POSITION_DATA'
export const SET_FILTERS_AVAILABLE = 'reports/SET_FILTERS'
